import React, { useState } from "react";
import UploadPage from "./UploadPage";
import DataEntryPage from "./DataEntryPage";
import MappingPage from "./MappingPage";
import "./UnifiedPage.css"; 

const UnifiedPage = ({ refreshTrigger, setRefreshTrigger }) => {
  const [showMappingPage, setShowMappingPage] = useState(false); // ✅ Standardmäßig versteckt
  
  // ✅ Funktion zur Aktualisierung von MappingPage nach Auswahl eines Sheets
  const triggerUpdate = () => {
    console.log("🔄 triggerUpdate wurde ausgelöst!");
    setRefreshTrigger((prev) => prev + 1);
    setShowMappingPage(true); // ✅ MappingPage wird nach erfolgreichem Laden sichtbar
  };

  return (
    <div className="unified-page">
      <h1>Alle Funktionen auf einen Blick</h1>

      <div className="section">
        <h2>1. CSV-Daten Hochladen</h2>
        <div className="component-wrapper">
          <UploadPage />
        </div>
      </div>

      <div className="section">
        <h2>2. Excel-Daten Hochladen & Verarbeiten</h2>
        <div className="component-wrapper">
          <DataEntryPage triggerUpdate={triggerUpdate} />
        </div>
      </div>

      {/* ✅ MappingPage wird nur angezeigt, wenn showMappingPage === true */}
      {showMappingPage && (
        <div className="section">
          <h2>3. Daten Mapping & Export</h2>
          <div className="component-wrapper">
            <MappingPage key={refreshTrigger} refreshTrigger={refreshTrigger} />
          </div>
        </div>
      )}
    </div>
  );
};

export default UnifiedPage;